export type EquipmentType =
  | "Attachments"
  | "Auto Crushers"
  | "Balers"
  | "Containers"
  | "Conveyance / Eddy Current"
  | "Furnaces"
  | "Miscellaneous"
  | "Motors"
  | "Scales"
  | "Shears"
  | "Shredders"
  | "Shredder Parts"
  | "Tire Recycling"
  | "Trucks and Trailers"
  | "Wire Processing"
  | "Please Specify"
  | unknown;

export enum EquipmentTypes {
  Attachments = "Attachments",
  AutoCrushers = "Auto Crushers",
  Balers = "Balers",
  Containers = "Containers",
  ConveyanceEddyCurrent = "Conveyance / Eddy Current",
  Furnaces = "Furnaces",
  Miscellaneous = "Miscellaneous",
  Motors = "Motors",
  Scales = "Scales",
  Shears = "Shears",
  Shredders = "Shredders",
  ShredderParts = "Shredder Parts",
  TireRecycling = "Tire Recycling",
  TrucksAndTrailers = "Trucks and Trailers",
  WireProcessing = "Wire Processing",
  Other = "Please Specify"
}
